import { Record } from "immutable";
import { SETTINGS_DATA_SOURCE_TYPES } from "@infinode/components/settings/constants";

const AnomalyDetectionDataItemRecord = Record({
  timestamp: null, // timestamp
  [SETTINGS_DATA_SOURCE_TYPES.NET_IMPORT]: null,
  [SETTINGS_DATA_SOURCE_TYPES.CONSUMED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.GENERATED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.STORAGE]: null
});
 
const createAnomalyDetectionDataItemRecord = dataItem => {
  return AnomalyDetectionDataItemRecord(dataItem);
};

export { createAnomalyDetectionDataItemRecord };

export default AnomalyDetectionDataItemRecord;
